import { ChevronRight } from "lucide-react";
import { Link } from "react-router";

/** "Parent › Current" trail above a detail page. */
export function Breadcrumb({ parent, current }: { parent: { to: string; label: string }; current: string }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <ol className="flex min-w-0 items-center gap-1 text-[0.8125rem] text-fg-muted">
        <li>
          <Link to={parent.to} className="rounded hover:text-fg hover:underline">
            {parent.label}
          </Link>
        </li>
        <li aria-hidden="true">
          <ChevronRight className="size-3.5" />
        </li>
        <li aria-current="page" className="min-w-0 truncate text-fg">
          {current}
        </li>
      </ol>
    </nav>
  );
}
